
const satisfiedCustomers = [
  "Expedite service partners",
  "Hope worldwide USA",
  "Hope worldwide UK",
  "N.E.P.A (Jamaica Gov.)",
  "The Merl Thomas foundation",
  "Chambers auto imports (JA)",
];

export default function CustomersMarquee() {
  return (
    <div className="w-full overflow-x-hidden bg-blue-50 border-b border-blue-200 py-2">
      <div className="whitespace-nowrap animate-marquee flex items-center gap-12 text-blue-900 font-semibold text-sm md:text-base">
        {satisfiedCustomers.map((item, idx) => (
          <span key={idx} className="mx-6">
            {item}
          </span>
        ))}
        {/* Duplicate for seamless loop */}
        {satisfiedCustomers.map((item, idx) => (
          <span key={"dup-"+idx} className="mx-6 opacity-60">
            {item}
          </span>
        ))}
      </div>
      <style jsx>{`
        .animate-marquee {
          display: flex;
          animation: marquee 32s linear infinite;
        }
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
